document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-waitlist-popup]');
  const closeButtons = document.querySelectorAll('[data-waitlist-close]');

  if (!popup) return;

  const form = popup.querySelector('#WaitlistPopupForm');
  const formContent = popup.querySelector('[data-waitlist-form-content]');
  const successContent = popup.querySelector('[data-waitlist-success]');

  const openPopup = () => {
    popup.classList.add('is-active');
    document.body.classList.add('waitlist-popup-open');

    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    document.body.classList.remove('waitlist-popup-open');

    setTimeout(() => {
      popup.classList.remove('is-active');
    }, 350);
  };

  const showSuccess = () => {
    if (formContent) formContent.hidden = true;
    if (successContent) successContent.hidden = false;
  };

  if (form) {
    form.addEventListener('submit', () => {
      sessionStorage.setItem('waitlist_popup_submitted', 'true');
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '.waitlist-trigger, a[href="#join-waitlist"], button[name="join-waitlist"]'
    );

    if (!trigger) return;

    event.preventDefault();
    openPopup();
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const wasWaitlistSubmitted =
    sessionStorage.getItem('waitlist_popup_submitted') === 'true';

  if (urlParams.get('customer_posted') === 'true' && wasWaitlistSubmitted) {
    openPopup();
    showSuccess();

    sessionStorage.removeItem('waitlist_popup_submitted');

    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname);
    }
  }
});